import { Inject, Injectable } from '@angular/core'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { BaseDecodedToken, GbBaseAuthService, GbCookieService } from 'libs/shared/utils/services/src'
import { EnvironmentModel } from 'apps/gb-dashboard/src/environments/environment.model'
import { Observable, map } from 'rxjs'

export interface DashboardDecodedToken extends BaseDecodedToken {
  u?: string // user
  st?: boolean // staff
  su?: boolean // superuser
  d?: string // distributor
}

@Injectable({
  providedIn: 'root',
})
export class GbDashboardAuthService extends GbBaseAuthService {
  isStaffSuperUserDistributor$: Observable<boolean> = this.accessToken$.pipe(
    map((token) => {
      const decodedToken = this.getDecodedAccessToken(token) as DashboardDecodedToken
      return !!decodedToken?.st || !!decodedToken.su || !!decodedToken?.d
    }),
  )
  constructor(
    protected gbCookieService: GbCookieService,
    @Inject(APP_CONFIG) protected appConfig: EnvironmentModel,
  ) {
    super(gbCookieService, appConfig)
  }

  get decodedAccessToken(): DashboardDecodedToken | undefined {
    return super.getDecodedAccessToken()
  }

  isDistributor(): boolean {
    return !!this.decodedAccessToken?.d
  }

  getDistributorId(): string | undefined {
    return this.decodedAccessToken?.d
  }

  isStaff(): boolean {
    return !!this.decodedAccessToken?.st || !!this.decodedAccessToken?.su
  }

  isStaffSuperUserDistributor(): boolean {
    return !!this.decodedAccessToken?.st || !!this.decodedAccessToken?.su || !!this.decodedAccessToken?.d
  }
}
